module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.4-card-detail.27036a25.png";